<template>
    <div id="wrapper">
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content">
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <h1 class="h3 mb-2 mt-2 text-gray-800">圖片管理</h1>
           
            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <!-- DataTales Example -->
            <div class="card shadow mb-4" v-if="!loading" >
                <div class="card-header py-3">
                    <label class="btn btn-info">
                        <input  style="display:none;" type="file" @change="PreviewImageMulti" accept="image/*"  multiple>
                        <i class="far fa-file-image"></i> 上傳相片
                    </label>
                    <span>格式限制 PNG、JPG   檔案大小上限3mb</span>
                </div>
                <div class="card-body">
                    <div class="copy-msg" v-if="copy">
                        <p>複製完成!</p>
                    </div>
                    <!-- <div class="row">
                        <div class="col-2 item-images" v-for="(item) in folders" :key="item.id" >
                            <i class="far fa-folder " style="font-size:75px"></i>                    
                            <div class="form-group mt-2">
                            <span style="font-size:12px"> {{item.path}}</span> <button type="button" class="btn btn-outline-danger btn-sm" v-on:click="deleteImg(item.name)" >刪除</button>
                            </div>
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-2 item-images" v-for="(item) in uploadData" :key="item.id" >
                            <img  :src="item.src" style="width:100%"/> 
                            <p class="card-text" style="font-size:12px">{{item.caption}}</p>
                            <div class="form-group" >
                                <p :class="{'text-danger': item.is_error, 'text-success': !item.is_error}">{{item.msg}}</p>
                            </div>
                            <div class="form-group" v-if="!item.is_upload && !item.is_error">
                                <p>Progress: {{item.uploadValue.toFixed()+"%"}}
                                <progress id="progress" :value="item.uploadValue" max="100" style="width:100%"></progress>  </p>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-3">
                        <div class="card" style="width: 10rem;"  v-for="(item) in images" :key="item.id">
                            <img class="card-img-top" :src="item.url" alt="Card image cap">
                            <div class="card-body">
                                <p class="card-text" style="font-size:12px">{{item.path}}</p>
                                <i class="far fa-copy fa-lg ml-2" @click="Copy(item.url)"></i> 
                                <i class="far fa-trash-alt fa-lg ml-2" @click="deleteImg(item.path)"></i>
                            </div>
                        </div>

                        <!-- <div class="item-images" v-for="(item) in images" :key="item.id" >
                            <img  :src="item.url" style="width:100%"/> 
                            <div class="form-group mt-2">
                            <span style="font-size:12px"> {{item.path}}</span> 
                                <i class="far fa-copy fa-lg ml-2" @click="Copy(item.url)"></i> 
                                <i class="far fa-trash-alt fa-lg ml-2"></i>
                            
                            </div>
                            <div class="form-group" v-if="!item.is_upload">
                                <p>Progress: {{item.uploadValue.toFixed()+"%"}}
                                <progress id="progress" :value="item.uploadValue" max="100" style="width:100%"></progress>  </p>
                            </div>
                            <div class="form-group" v-if="item.is_upload">
                                <p></p>
                            </div>
                        </div> -->
                    </div>

                    
                    
                </div>
            </div>
            

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->
        <Footer></Footer>
      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import moment from 'moment'
export default {
    name: 'User',
    data () {
        return {
            folders:[],
            images:[],
            loading:true,
            copy:false,
            uploadData:[]
        }
    },
    watch: {
        copy:function() {
            if ( this.copy ) {
                var vm = this;
                setTimeout(function(){ vm.copy = false }, 2000);
            }
        } 
    },
    mounted () {
        //  alert('圖片容量到達上限，請先刪除未使用圖片。');
        this.Get();
    },
    methods: {
        Get(){
            this.loading = true;
            var vm = this;
            const storageRef= fb.storage().ref('other');
            // Find all the prefixes and items.
            storageRef.listAll().then((res) => {
                res.prefixes.forEach((folderRef) => {
                // All the prefixes under listRef.
                // You may call listAll() recursively on them.
                    var item = {
                        path:folderRef._delegate._location.path,
                    }
                    //  vm.folders.push(item);
                
                });
                res.items.forEach((itemRef) => {
                // All the items under listRef.
                    vm.displayImage(itemRef);
                });

                this.loading = false;
                
            }).catch((error) => {
                // Uh-oh, an error occurred!
            });
        },
        displayImage(imageRef) {
            var vm = this;
            vm.images = [];
            imageRef.getDownloadURL().then(function(url) {
                // TODO: Display the image on the UI
                var array = imageRef.name;
                var path = array[array.length-1]
                var item = {
                    path:array,
                    url:url,
                    uploadValue:100,
                    is_upload:true
                }
                vm.images.push(item);
            }).catch(function(error) {
                // Handle any errors
            });
        },
        Copy(url){
            const el = document.createElement('textarea');
            el.value = url;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);

            this.copy = true;
            var funcNum = this.GetUrlParam( 'CKEditorFuncNum' );
            window.opener.CKEDITOR.tools.callFunction( funcNum, url );

            window.close()
        },
        GetUrlParam( paramName ) {
            var reParam = new RegExp( '(?:[\?&]|&)' + paramName + '=([^&]+)', 'i' );
            var match = window.location.search.match( reParam );

            return ( match && match.length > 1 ) ? match[1] : null;
        },
        PreviewImageMulti(event) {

            var index = this.uploadData.length;
           
            for (var i = 0 ; i < event.target.files.length ; i++ ) {

                var tmp = {};
                index = index + 1;
                tmp.imageData =  event.target.files[i];
                tmp.id = index ;
                tmp.uploadValue = 0;
                tmp.is_upload = false;
                tmp.caption = event.target.files[i].name;
                tmp.name = encodeURIComponent(event.target.files[i].name).replace(/['()]/g, escape);
                tmp.src = URL.createObjectURL(event.target.files[i]);
                tmp.is_error = false;
                tmp.msg = '';
                this.uploadData.push(tmp);

                if (( event.target.files[i].size / 1024 / 1024 ) > 3 ) {
                    tmp.is_error = true;
                    tmp.msg = '檔案大小上限3mb';
                } else if ( event.target.files[i].type.toLowerCase().indexOf("jpeg") > -1 || event.target.files[i].type.toLowerCase().indexOf("png") > -1 ){
                    tmp.msg = '上傳中';
                    this.onUploadMulti(tmp);
                } else {
                   
                    tmp.is_error = true;
                    tmp.msg = '僅限定副檔名為PNG、JPG圖';
                     console.log('fail')
                    console.log(tmp.is_error);
                }
            }
        },
        onUploadMulti(tmp){

            var vm = this;
            this.picture=null;

            const storageRef= fb.storage().ref('other/' + tmp.name).put(tmp.imageData);

            storageRef.on('state_changed',
                snapshot=>{
                    this.uploadData.find(x => x.id === tmp.id).uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                }, 
                error => {
                    console.log(error.message)
                    alert('圖片容量到達上限，請先刪除未使用圖片。');
                }, 
                () => {
                this.uploadData.find(x => x.id === tmp.id).uploadValue=100;
                
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.uploadData.find(x => x.id === tmp.id).src =url;
                    this.uploadData.find(x => x.id === tmp.id).is_upload = true;
                    this.uploadData.find(x => x.id === tmp.id).msg = '上傳成功'
                    //   check all image upload done.
                    if ( this.uploadData.filter(x => x.is_upload == true).length == this.uploadData.length ) {
                        //  vm.uploadData = [];
                        vm.Get();
                    }
                    console.log('success');
                });
            
            }
            );
        },
        deleteImg(name) {
        
            var vm = this;
            if ( confirm("確定要刪除" + name + "?") ) {

                this.Beforesend();
            
                const storageRef= fb.storage().ref('other/' +name).delete().then(() => {
                    alert("刪除成功");
                    vm.Get();
                    this.Aftersend();
                }).catch((error) => {
                    console.log(error);
                    this.Aftersend();
                });
            }
        }
    }
}
</script>
<style scoped>
i {
    color:black;
    cursor: pointer;
}
.btn-info i {
    color:white !important;
}
.copy-msg{
    width:150px;
    height:50px;
    background-color: rgba(158,140,140,0.2);
    position:absolute;
    left:40%;
    bottom: 50px;
    border-radius:10px;
    text-align: center;
    padding:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Image.vue